import 'css-chunksrc/client/scenes/calendar/week/dayCreationMenu/dateFields/dateTimeInput/styles.scss';export default {
  "dateTimeInput": "_dateTimeInput_l7kcf_1",
  "input": "_input_l7kcf_6",
  "placeholder": "_placeholder_l7kcf_22",
  "value": "_value_l7kcf_27",
  "calendarInput": "_calendarInput_l7kcf_32",
  "calendar": "_calendar_l7kcf_32",
  "timeList": "_timeList_l7kcf_48",
  "timeListWrapper": "_timeListWrapper_l7kcf_57",
  "time": "_time_l7kcf_48",
  "timeName": "_timeName_l7kcf_69",
  "invalid": "_invalid_l7kcf_75",
  "timeInput": "_timeInput_l7kcf_80"
};